<template>
  <div
    id="project-wrapper"
    class="project-wrapper"
  >
    <ProjectHeaderLogo />
    <ProjectHeaderRouting />
    <ProjectHeaderSwitcher />
  </div>
</template>

<script setup>
import ProjectHeaderLogo from "@/components/GlobusHeader/HeaderProject/ProjectHeaderLogo.vue";
import ProjectHeaderRouting from "@/components/GlobusHeader/HeaderProject/ProjectHeaderRouting.vue";
import ProjectHeaderSwitcher from "@/components/GlobusHeader/HeaderProject/ProjectHeaderSwitcher.vue";
</script>

<style lang="scss" scoped>

.project-wrapper {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  height: 48px;
  padding: 10px 6px 10px 14px;
  user-select: none;
  border-radius: 50px;
  background: #fff;
  box-shadow: 0 0 33px 0 #7090B029;
  gap: 20px;
}

.title-login-box {
  display: flex;
  align-items: center;
  justify-content:center;
}
</style>
